<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <v-text-field
              ref="form"
              class="mr-1"
              prepend-icon="search"
              label="Search by Card No."
              v-model="searchItem"
              clearable
              hide-details
            ></v-text-field>

            <v-spacer></v-spacer>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="approveAllTransaction()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16M13,14L20,7L18.59,5.59L13,11.17L9.91,8.09L8.5,9.5L13,14Z"
                  />
                </svg>
              </v-btn>
              <span>Approve 1</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="approveAllTransaction2()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H8V4H20V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16M18.53,8.06L17.47,7L12.59,11.88L10.47,9.76L9.41,10.82L12.59,14L18.53,8.06Z"
                  />
                </svg>
              </v-btn>
              <span>Approve 2</span>
            </v-tooltip>

            <refresh-button @refresh="refreshTable()"></refresh-button>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <!-- Insert View Dialog Content BELOW-->

                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :userData="viewUser"
                      :accessCards="accessCards"
                      :readonly="dialogType === 'view'"
                      hidePassword
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <v-dialog v-model="assignDialog" scrollable max-width="300px">
              <v-card>
                <v-card-title>Select Role</v-card-title>

                <v-divider></v-divider>

                <v-card-text style="height: 300px;">
                  <v-radio-group v-model="role" column>
                    <v-radio
                      v-for="(vehicle, v) in rolesItems"
                      :key="v"
                      color="primary"
                      :label="vehicle.text"
                      :value="vehicle.value"
                    ></v-radio>
                  </v-radio-group>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" flat @click="closeAssignDialog()"
                    >Close</v-btn
                  >
                  <v-btn
                    color="primary"
                    flat
                    :disabled="role === null || role === viewData.role_id"
                    @click="saveAssignDialog()"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <message-dialog
              :dialog="openConfirmDialog"
              title="Approval"
              message="Are you sure you want to approved this transaction?"
              @save="saveApproveTransaction()"
              @close="closeConfirmDialog"
              :loading="confirmLoading"
            ></message-dialog>

            <message-dialog
              :dialog="openConfirmDialog2"
              title="Approval"
              message="Are you sure you want to approved all this transaction?"
              @save="saveApproveAllTransaction()"
              @close="closeConfirmDialog"
              :loading="confirmLoading"
            ></message-dialog>

            <message-dialog
              :dialog="openConfirmDialog3"
              title="Approval"
              message="Are you sure you want to approved all this transaction?"
              @save="saveApproveAllTransaction2()"
              @close="closeConfirmDialog"
              :loading="confirmLoading"
            ></message-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container grid-list-lg fluid style="padding:" class="mt-3">
            <v-layout>
              <v-flex md2 style="padding:">
                <v-menu
                  ref="dateFromMenu"
                  :close-on-content-click="false"
                  v-model="dateFromMenu"
                  :disabled="queryParams.search ? true : false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    :disabled="queryParams.search ? true : false"
                    label="Date"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md2 style="padding:">
                <v-select
                  v-model="filterStatusType"
                  :items="filterStatusTypes"
                  label="Status Type"
                  :nudge-right="40"
                  offset-y
                  full-width
                  min-width="290px"
                  solo
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4> </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterPosition"
                :items="filterPositions"
                label="Position"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left">{{ props.item.card_no }}</td>
              <td class="text-xs-center">
                {{
                  props.item.transaction_date
                    ? $dateFormat(props.item.transaction_date, "YYYY-MM-DD")
                    : "--"
                }}
              </td>

              <td class="text-xs-center">
                {{
                  props.item.transaction_date
                    ? $dateFormat(props.item.transaction_date, "HH:mm:ss")
                    : "--"
                }}
              </td>

              <td class="text-xs-left text-uppercase">
                {{ props.item.transaction_type }}
              </td>
              <td class="text-xs-right">
                {{ $amountInPeso(props.item.previous_balance) }}
              </td>
              <td class="text-xs-right">
                {{ $amountInPeso(props.item.amount) }}
              </td>
              <td class="text-xs-right">
                {{ $amountInPeso(props.item.remaining_balance) }}
              </td>
              <td
                v-if="props.item.approved_by && props.item.approved2_by"
                class="text-xs-left text-uppercase"
              >
                {{ "Approved" }}
              </td>
              <td
                v-else-if="props.item.approved_by"
                class="text-xs-left text-uppercase"
              >
                Approved by
                {{
                  `${props.item.approved_by.first_name} ${props.item.approved_by.last_name}`
                }}
              </td>
              <td
                v-else-if="props.item.approved2_by"
                class="text-xs-left text-uppercase"
              >
                Approved by
                {{
                  `${props.item.approved2_by.first_name} ${props.item.approved2_by.last_name}`
                }}
              </td>
              <td v-else class="text-xs-left text-uppercase">
                {{ "Pending" }}
              </td>

              <td class="text-no-wrap text-xs-center">
                <v-tooltip top>
                  <v-btn
                    fab
                    dark
                    v-if="
                      $moduleAccess('approve_approve_missing_transaction') &&
                        props.item.approved_by === null
                    "
                    @click="approveTransaction(props.item)"
                    icon
                    slot="activator"
                  >
                    <v-icon color="teal">assignment_turned_in</v-icon>
                  </v-btn>
                  <span>Approve 1</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    fab
                    dark
                    v-if="
                      $moduleAccess('approve2_approve_missing_transaction') &&
                        props.item.approved2_by === null
                    "
                    @click="approveTransaction2(props.item)"
                    icon
                    slot="activator"
                  >
                    <v-icon color="teal">assignment_turned_in</v-icon>
                  </v-btn>
                  <span>Approve 2</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/EmployeeDetailsContainer";
import XLSX from "xlsx";
import JsPdf from "jspdf";
import "jspdf-autotable";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      rolesItems: [],
      openFilter: false,
      filterPositions: [],
      filterPosition: "",
      clockMode: "",
      openFilter: false,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      heightMap: "",
      widthMap: "",
      mapDialog: false,
      center: { lat: 14.4793, lng: 121.0198 },
      zoom: 20,
      title: "Approve Missing Transaction",
      items: [],
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Card No.",
          align: "left",
          value: "card_no",
          sortable: true,
        },
        {
          text: "Date",
          align: "center",
          value: "date",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
        },
        {
          text: "Transaction Type",
          align: "left",
          value: "transaction_type",
          sortable: false,
        },
        {
          text: "Previous Balance",
          align: "right",
          value: "previous_balance",
          sortable: false,
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "right",
          value: "remaining_balance",
          sortable: false,
        },
        {
          text: "Status",
          align: "left",
          value: "status",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      employeeHeaders: [
        {
          text: "Employee Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Role",
          align: "left",
          value: "name",
          sortable: false,
        },
      ],
      filterWirelessTransaction: null,
      items: [],
      employeeItems: [],

      dialogStatus: false,
      openConfirmDialog: false,
      openConfirmDialog2: false,
      openConfirmDialog3: false,
      viewData: {},
      viewUser: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: "All", value: 0 },
      ],
      selected: [],

      filterStatusTypes: [
        {
          text: "PENDING",
          value: 1,
        },
        {
          text: "APPROVED BY",
          value: 2,
        },
        {
          text: "APPROVED",
          value: 3,
        },
      ],
      filterStatusType: null,
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      positions: [
        {
          text: "FC SUPPORT",
          value: "fc support",
        },
        {
          text: "HEAD SUPPORT",
          value: "head support",
        },
      ],
      filterWirelessTransaction: null,
      queryParams: {
        search: null,
        limit: 10,
        offset: 0,
        date_from: null,
        date_to: null,
        status_type: null,
      },
      totalItems: 0,
      show: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewItems: [],
      date_from: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      date_to: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      accessCards: [],
      vehicles: [],
      role: null,
      assignDialog: false,
    };
  },
  beforeDestroy() {
    window.stop();
  },

  watch: {
    filterStatusType: async function() {
      if (this.filterStatusType) {
        this.queryParams.offset = 0;
        this.queryParams.status_type = this.filterStatusType;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.status_type = null;
      }

      await this.getData();
    },

    filterWirelessTransaction: async function() {
      this.resetTable();
      if (
        this.filterWirelessTransaction !== null &&
        this.filterWirelessTransaction !== undefined &&
        this.filterWirelessTransaction !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.transaction_type = this.filterWirelessTransaction;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.transaction_type = null;
        this.getData();
      }
    },
  },
  created: async function() {
    this.resetTable();
    this.queryParams.date_from = this.$dateFormat(new Date(), "YYYY-MM-DD");
    // this.queryParams.date_to = this.$dateFormat(new Date(), "YYYY-MM-DD");

    this.getData();
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },

    pageLimit: {
      get() {
        return 10;
      },
      set(value) {
        // this.resetTable();
        this.queryParams.limit = value;
        this.queryParams.offset = 0;
      },
    },
    dateFrom: {
      get() {
        this.queryParams.date_from = this.date_from;
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.queryParams.date_to = value;
        this.date_from = value;

        this.getData();
      },
    },
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_from;
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;

        this.getData();
      },
    },
  },
  methods: {
    async setStatusType() {
      let cardTransTypes = [];
      try {
        this.$store.dispatch("startLoading");
        // Get all data from transaction type service.
        cardTransTypes = await Services.getTransactionTypes({});
        //  Set all the items for the filter
        if (cardTransTypes.data.data) {
          cardTransTypes.data.data.map((item, i) => {
            this.filterStatusTypes.push({
              text: item.name.toUpperCase(),
              value: item.name.toLowerCase(),
            });
            if (i + 1 === cardTransTypes.data.data.length) {
              this.filterStatusTypes.unshift({
                text: "PAYMENT",
                value: "payment",
              });
            }
          });
        }
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }
      this.$store.dispatch("endLoading");
    },

    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;

      this.getData();
    },
    async getData() {
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");

      try {
        // Query Data
        let response = (await Services.getMissingTransactions(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = await this.items.concat(response.data);

        // this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.$store.dispatch("endLoading");
    },

    async getProjects() {
      // Start Loading
      this.assignItems = [];
      this.assignItems = response.projects;
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getEmployee(id);
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      return data;
    },
    async setUser(id) {
      var data = {};

      try {
        const response = await Services.getUser(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    async setEmployees() {
      this.employeeItems = [];
      this.employeeItems = (await Services.getUnassignedEmployees()).data;
    },

    async setRoles() {
      let items;

      try {
        items = (await Services.getRoles({})).data.data;
        this.rolesItems = await Promise.all(
          items.map(async (item) => {
            const id = item.id;
            const name = item.name.toUpperCase();

            return {
              value: id,
              text: name,
            };
          })
        );
      } catch (error) {
        console.log(error);
      }
    },

    async setAccessCards() {
      this.accessCards = [];

      const response = await Services.getAccessCard(
        this.viewData.access_card_id
      );
      const data = await response.data;

      this.accessCards.push({
        text: data.embedded_id.toUpperCase(),
        value: data.id,
      });
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      await this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
        this.openConfirmDialog2 = true;
        this.openConfirmDialog3 = true;
      }
    },
    approveTransaction(data) {
      this.openConfirmDialog = true;
      this.dialogType = "approve";
      this.viewData = data;
    },
    approveTransaction2(data) {
      this.openConfirmDialog = true;
      this.dialogType = "approve2";
      this.viewData = data;
    },
    approveAllTransaction(data) {
      this.openConfirmDialog2 = true;
      this.dialogType = "approveAllTransaction";
      this.getData();
    },
    approveAllTransaction2(data) {
      this.openConfirmDialog3 = true;
      this.dialogType = "approveAllTransaction2";
      this.getData();
    },
    async saveApproveTransaction() {
      this.confirmLoading = true;

      const body = {
        approve: this.dialogType == "approve" ? 1 : 2,
      };

      try {
        const response = await Services.approveMissingTransaction(
          this.viewData.id,
          body
        );

        if (response.status === 201 || response.status === 204) {
          await this.closeConfirmDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Transaction has been approved!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.confirmLoading = await false;
    },

    async saveApproveAllTransaction() {
      this.confirmLoading = true;

      const items = this.items;

      let aNewArr = [];

      for (let i = 0; i < items.length; i++) {
        const newItems = items[i];

        aNewArr.push(newItems.id);
      }
      this.confirmLoading = await false;

      try {
        const response = await Services.approveAllMissingTransaction(aNewArr);

        if (response.status === 201 || response.status === 204) {
          await this.closeConfirmDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Transaction has been approved!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.confirmLoading = await false;
    },

    async saveApproveAllTransaction2() {
      const items = this.items;

      let aNewArr = [];

      for (let i = 0; i < items.length; i++) {
        this.confirmLoading = true;

        const newItems = items[i];

        aNewArr.push(newItems.id);
      }
      this.confirmLoading = await false;

      try {
        const response = await Services.approveAllMissingTransaction2(aNewArr);

        if (response.status === 201 || response.status === 204) {
          await this.closeConfirmDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Transaction has been approved!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        console.log(error);
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.confirmLoading = await false;
    },

    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteEmployee(aNewArr);

        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();

          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Employee has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
      this.openConfirmDialog2 = false;
      this.openConfirmDialog3 = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },

    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
    },

    async initMap(data) {
      this.heightMap = 80;
      this.widthMap = 87.5;
      this.center = { lat: data.lat, lng: data.long };
      await this.$refs.map.initializeMap();
      await this.$refs.map.addMarker(data);
    },
    refreshTable() {
      this.date_from = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.date_to = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.items = [];
      this.filterStatusType = null;
      // this.page = page;
      this.resetTable();
      this.getData();
    },
    resetTable() {
      this.items = [];
      this.queryParams.limit = 10;
      this.queryParams.offset = 0;
      this.queryParams.dateFromMenu = null;
      this.queryParams.dateToMenu = null;
    },
    async loadMore() {
      this.queryParams.offset += this.queryParams.limit;

      if (this.queryParams.offset >= this.totalItems) return;

      this.queryParams.offset = this.items.length;
      this.queryParams.limit = 10;

      await this.getData();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    openDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = [];

      this.viewItems.push(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },

    async downloadExcel() {
      this.$store.dispatch("startLoading");

      let items = [];

      let params = this.queryParams;

      params.limit = null;
      params.offset = null;

      try {
        let response = (await Services.getMissingTransactions(params)).data;

        // Assign the reponse data to items to be display on table
        items = response.data;

        this.$store.dispatch("endLoading");
      } catch (error) {
        this.$store.dispatch("endLoading");

        return this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      //   header.unshift("");
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 25 });
        wscols.push({ wch: 25 });
        wscols.push({ wch: 25 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
      }

      // theItem.push(this.items[e].
      // this.$dateFormat
      for (let e = 0; e < items.length; e++) {
        let theItem = [];

        theItem.push(items[e].card_no ? items[e].card_no.toUpperCase() : "--");

        theItem.push(
          items[e].transaction_date
            ? this.$dateFormat(items[e].transaction_date, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].transaction_date
            ? this.$dateFormat(items[e].transaction_date, "HH:mm")
            : "--"
        );
        theItem.push(items[e].transaction_type);
        theItem.push(items[e].previous_balance);
        theItem.push(items[e].amount);
        theItem.push(items[e].remaining_balance);

        if (items[e].approved_by && !items[e].approved2_by) {
          theItem.push(
            `APPROVED BY ${items[e].approved_by.first_name} ${items[e].approved_by.last_name}}`
          );
        } else if (items[e].approved2_by && !items[e].approved_by) {
          theItem.push(
            `APPROVED BY ${this.items[e].approved_by2.first_name} ${items[e].approved_by2.last_name}}`
          );
        } else if (items[e].approved_by && items[e].approved2_by) {
          theItem.push("APPROVED");
        } else {
          theItem.push("PENDING");
        }

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.employeeItems.slice();
    },
    async openSubscribeDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "assign";
      this.subscribeDialog = true;
      this.viewData = data;

      this.viewData = await this.setData(data.id);
      this.assignedItems = await this.viewData.projects;
      await this.getProjects();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async closeSubscribeDialog() {
      this.selected = [];
      this.viewData = {};
      this.closeConfirmDialog();
      this.dialogType = "";
      this.subscribeDialog = false;
    },
    saveSubscribeDialog() {
      this.openConfirmDialog = true;
      this.openConfirmDialog2 = true;
      this.openConfirmDialog3 = true;
    },
    notSubscribe(data) {
      for (var e = 0; e < this.assignedItems.length; e++) {
        if (this.assignedItems[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    showSubcribe(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    subscribeToProject(data) {
      this.selected.push(data);
    },
    unsubscribeToProject(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          this.selected.splice(e, 1);
        }
      }
    },
    async saveConfirmedSubscribeDialog() {
      this.confirmLoading = true;

      const projects = this.selected.map((project) => {
        return {
          id: project.id,
          position: project.SubCompanyProject.position,
        };
      });
      const body = {
        projects: projects,
        employee_id: this.viewData.id,
      };
      try {
        const response = await Services.assignEmployeetoProject(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeSubscribeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Project/s has been assigned to Employee!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },

    async setFilterPosition() {
      const items = (
        await Services.getEmployees({
          limit: this.items.count,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data.data;

      let toPush = [];

      items.forEach((item1) => {
        item1.projects.forEach((item2) => {
          toPush.push(item2.ProjectEmployee.position);
        });
      });

      let unique = [...new Set(toPush)];

      unique.forEach((position) => {
        let body = {
          text: position.toUpperCase(),
          value: position.toUpperCase(),
        };
        this.filterPositions.push(body);
      });
    },
    async openAssignDialog(data) {
      this.dialogType = "assign";

      await this.setRoles();

      this.role = data.role_id;

      this.viewData = await data;

      this.assignDialog = true;
    },
    async saveAssignDialog() {
      const body = {
        role_id: this.role,
      };

      try {
        const response = await Services.changeEmployeeAssignedRole(
          this.viewData.id,
          body
        );

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAssignDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Role has been change!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
    },
    closeAssignDialog() {
      this.role = null;
      this.assignDialog = false;
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
